import { Alert, Button, Center, Paper, PasswordInput, Stack, Text, TextInput, Title } from "@mantine/core";
import { type FormEvent, useState } from "react";

import { ApiError } from "../api/client";
import { useAuth } from "../auth/AuthProvider";

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Sign-in failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Center mih="100vh" p="md">
      <Paper withBorder shadow="sm" p="xl" w="100%" maw={400}>
        <form onSubmit={submit}>
          <Stack>
            <div>
              <Title order={2}>IIoT Platform</Title>
              <Text c="dimmed" size="sm">Sign in to your company workspace</Text>
            </div>
            {error && <Alert color="red">{error}</Alert>}
            <TextInput label="Email" type="email" autoComplete="username" required value={email}
              onChange={(e) => setEmail(e.currentTarget.value)} />
            <PasswordInput label="Password" autoComplete="current-password" required value={password}
              onChange={(e) => setPassword(e.currentTarget.value)} />
            <Button type="submit" loading={busy}>Sign in</Button>
          </Stack>
        </form>
      </Paper>
    </Center>
  );
}
